export interface Transaction {
  /// <summary>
  /// Description Text of the transaction
  /// </summary>
  DescriptionText: string;

  /// <summary>
  /// Transaction Amount (in pence)
  /// </summary>
  Amount: number;

  /// <summary>
  /// Transaction Reference
  /// </summary>
  TransactionRef: number;

  /// <summary>
  /// Transaction Date
  /// </summary>
  TransactionDate: Date;

  /// <summary>
  /// Transaction Date in UTC
  /// </summary>
  TransactionDateUTC: Date;

  /// <summary>
  /// Point of sale
  /// </summary>
  POS: string;

  /// <summary>
  /// Card Balance
  /// </summary>
  CardBalance: number;

  /// <summary>
  /// Account Balance
  /// </summary>
  AccountBalance: number;

  /// <summary>
  /// Card Account Number
  /// </summary>
  AccountNumber: number;

  /// <summary>
  /// Card Number
  /// </summary>
  ACN: number;

  /// <summary>
  /// External Vender Reference
  /// </summary>
  ExternalVendorRef: string;

  /// <summary>
  /// Account Description Id
  /// </summary>
  AccountDescriptionId: number;

  /// <summary>
  /// Action Id
  /// </summary>
  ActionId: number;

  /// <summary>
  /// Transaction Description Text
  /// </summary>
  TransactionDescription: string;

  /// <summary>
  /// Transaction Location
  /// </summary>
  Location: string;

  Type: TransactionType;
}

export enum TransactionType {
  payment,
  loyalty,
  ecash,
  cardlink,
}
